import { StoreState } from '../types';
import { explorer } from './Explorer';

const initialState: StoreState = {
  explorer
};

export default initialState;
